module.exports = "https://cdn.realtymogul.com/static/media/icon_partner.e9981b56.svg";